import React from "react";

interface OutOfStockLabelProps {
  isInStock: boolean;
  isReplacementEligible: boolean;
  isCarouselProductBox: boolean;
  outOfStockStyle: string | undefined;
}

const OutOfStockLabel = ({
  isInStock,
  isReplacementEligible,
  isCarouselProductBox,
  outOfStockStyle,
}: OutOfStockLabelProps) => {
  const shouldShowOutOfStock =
    !isInStock && !isReplacementEligible && isCarouselProductBox;

  if (shouldShowOutOfStock) {
    return (
      <span className="pricing">
        <span
          className={`
              ${outOfStockStyle} price small
          `}
        >
          Out Of Stock
        </span>
      </span>
    );
  }

  return null;
};

export default OutOfStockLabel;
